import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO.jsx";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Record scratch – Page not found | MusicBase"
        description="We couldn’t find the page you were looking for. Go back to the homepage or explore MusicBase."
        robots="noindex, nofollow"
      />
      <main
        style={{
          minHeight: "calc(100vh - var(--appbar-h))",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px 16px",
        }}
      >
        <section
          style={{
            maxWidth: 520,
            width: "100%",
            backgroundColor: "#fef2f2",
            borderRadius: 24,
            border: "1px solid #fecaca",
            padding: "24px 20px 20px",
            color: "#b91c1c",
            boxShadow: "0 16px 35px rgba(0,0,0,0.06)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: 16,
            }}
          >
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: "999px",
                border: "2px solid #b91c1c",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: 16,
              }}
            >
              !
            </div>
            <span style={{ opacity: 0 }}>×</span>
          </div>

          <h1
            style={{
              fontSize: 24,
              lineHeight: 1.2,
              marginBottom: 12,
              fontWeight: 700,
            }}
          >
            Record scratch.
          </h1>

          <p
            style={{
              fontSize: 15,
              lineHeight: 1.6,
              color: "#7f1d1d",
              marginBottom: 20,
            }}
          >
            We couldn't find the details for this release. It might not be available right now, but feel free to explore other releases.
          </p>

          <div
            style={{
              display: "flex",
              gap: 10,
              flexWrap: "wrap",
            }}
          >
            <Link
              to="/"
              style={{
                padding: "10px 18px",
                borderRadius: 999,
                backgroundColor: "#b91c1c",
                color: "#fff",
                textDecoration: "none",
                fontWeight: 600,
                textAlign: "center",
                flexShrink: 0,
              }}
            >
              Go to homepage
            </Link>
            <button
              type="button"
              onClick={() => window.history.back()}
              style={{
                padding: "10px 18px",
                borderRadius: 999,
                border: "1px solid #fecaca",
                backgroundColor: "#fff",
                color: "#b91c1c",
                fontWeight: 500,
                cursor: "pointer",
                textAlign: "center",
                flexShrink: 0,
              }}
            >
              Go back
            </button>
          </div>
        </section>
      </main>
    </>
  );
}
